import { render, staticRenderFns } from "./NodeViewUserMention.vue?vue&type=template&id=09c67d0a&"
import script from "./NodeViewUserMention.vue?vue&type=script&setup=true&lang=js&"
export * from "./NodeViewUserMention.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports